import { Component, Input } from '@angular/core';
import { ContactPerson } from '../../models/contact';
import { MatIcon } from '@angular/material/icon';

interface ContactRowField {
  key: 'email' | 'businessPhone' | 'phone' | 'address';
  label: string;
  icon: string;
  variant: 'email' | 'phone' | 'location';
  showLabel: boolean;
}

// Shared by both the Person and Department cards — per design QA, the email/office/mobile/
// address rows render identically between the two, aside from the location pin's color
// (`cardType` flips just that).
@Component({
  selector: 'app-contact-rows',
  imports: [MatIcon],
  templateUrl: './contact-rows.component.html',
  styleUrl: './contact-rows.component.scss',
  standalone: true
})
export class ContactRowsComponent {
  @Input() contact: ContactPerson | null = null;
  @Input() cardType: 'person' | 'department' = 'person';

  readonly contactFields: ContactRowField[] = [
    { key: 'email', label: 'Email', icon: 'mail_outline', variant: 'email', showLabel: false },
    { key: 'businessPhone', label: 'Office', icon: 'call', variant: 'phone', showLabel: true },
    { key: 'phone', label: 'Mobile', icon: 'smartphone', variant: 'phone', showLabel: true },
    { key: 'address', label: 'Address', icon: 'location_on', variant: 'location', showLabel: false }
  ];
}
